var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "options-container" },
    _vm._l(_vm.options, function(option, i) {
      return _c(
        "div",
        {
          key: option.value + "-" + i,
          staticClass: "form-check form-check-inline"
        },
        [
          _c("Checkbox", {
            attrs: {
              label: option.label,
              value: _vm.checked(option),
              disabled: !_vm.canEdit
            },
            on: {
              input: function($event) {
                return _vm.toggleOption(option.value, $event)
              }
            }
          })
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }